"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SlipRoad.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SlipRoad = function SlipRoad(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 166.74 149.5"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Slip Road Icon"), _react2.default.createElement("g", {
    className: "slip-road-sign",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "up-arrow",
    d: "M166.74 30.54L135.79.03V0l-30.96 30.53 9.24 9.23 15.05-14.37V149.5h13.06V25.13l15.33 14.65 9.23-9.24z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "arrow",
    d: "M66.11 57.12l-43.47-.05.07 13.06 20.85.35L.04 114.64l9.29 9.17 43.66-44.3.62 21.17 13.06-.08-.57-43.47.01-.01z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "dashed-lines",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "line",
    d: "M83.2 18h9v23h-9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "line-2",
    "data-name": "line",
    d: "M83.2 56h9v33h-9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    "data-name": "line",
    d: "M83.2 104h9v23h-9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: undefined
  }))));
};
exports.default = SlipRoad;